import React from 'react';
import { useNavigate } from 'react-router-dom';

const EventHeader = ({ event, timeRemaining, stopwatchTime, formatStopwatchTime, formatDate }) => {
  const navigate = useNavigate();

  return (
    <div className="p-6 border-b border-gray-200 flex justify-between items-center bg-gradient-to-r from-[#F15213] to-[#ff6b3d]">
      <div className="flex flex-col">
        <h2 className="text-3xl font-bold text-white">{event.event.name}</h2>
        {event?.event?.eventStatus === "In Progress" && (
          <div className="text-white mt-2 text-xl font-mono">
            Duration: {formatStopwatchTime(stopwatchTime)}
          </div>
        )}
        {event?.event?.eventStatus === "Completed" && event?.event?.endDate && (
          <div className="text-white mt-2 text-xl">
            Ended on: {formatDate(event.event.endDate)}
          </div>
        )}
      </div>
      <button
        onClick={() => navigate(-1)}
        className="px-4 py-2 bg-white text-[#F15213] rounded-lg hover:bg-gray-50 transition-colors duration-200 font-medium"
      >
        Back
      </button>
    </div>
  );
};

export default EventHeader; 